<template>
  <div
    :style="`background-image : url(${cdnImage(page.heroImage?.asset?._ref).bg}); min-height: 150px; background-size: cover; background-repeat: no-repeat; background-position: bottom right;`"
    :class="{
      'flex flex-col items-center justify-center gap-6 bg-www-color-accent-dark px-6 py-100px md:px-0': true,
    }"
    data-test="resourceCenterEventsHero"
  >
    <h1
      v-sc-non-empty-string="page.title"
      :class="{
        'text-center text-28px font-extrabold leading-8 text-www-color-white lg:text-6xl': true,
      }"
    >
      {{ page.title }}
    </h1>
    <p
      :class="{
        'text-center text-lg text-www-color-white': true,
      }"
    >
      {{ page.description }}
    </p>
    <ButtonRow
      v-if="page.heroNavigationCtaButtons"
      v-bind="page.heroNavigationCtaButtons"
    />
  </div>
</template>

<script setup lang="ts">
import type { PageResourceCenterEventsIndexResult } from '~/sanity/types';
import ButtonRow from '~/components/Atoms/ButtonRow/ButtonRow.vue';
type EventPageHeroProps = {
  page: NonNullable<PageResourceCenterEventsIndexResult>;
};
defineProps<EventPageHeroProps>();
</script>

<style lang="scss" scoped></style>
